module.exports = __webpack_public_path__ + "00f8ac10c2aca11027cc21a221da4730.svg";